<script>
  import options from './SchemaMarkupButton.options'
  export default options
</script>

<template>
  <button type="button" class="kb-button">
    <slot>{{ label }}</slot>
  </button>
</template>
